import { Switch } from '@headlessui/react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const PrivacyPolice = ({ partner, agreed, setAgreed }) => {
  const { t } = useTranslation()

  const { customPrivacyLink, customPrivacyLinkReference } = JSON.parse(
    partner.app_settings?.components || '{}'
  )

  const partnerName = customPrivacyLinkReference
    ? 'Aivy\u00A0GmbH'
    : partner.name.replace(/ /g, '\u00A0')

  return (
    <div className='flex items-start'>
      <div className='flex-shrink-0'>
        <Switch
          checked={agreed}
          onChange={setAgreed}
          className={clsx(
            agreed ? 'bg-indigo-600' : 'bg-gray-200',
            'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
          )}
        >
          <span className='sr-only'>Agree to policies</span>
          <span
            aria-hidden='true'
            className={clsx(
              agreed ? 'translate-x-5' : 'translate-x-0',
              'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            )}
          />
        </Switch>
      </div>
      <div className='ml-3 mt-0.5'>
        <p className='text-sm text-gray-700'>
          {`${t('datapolicy.description.first')} `}
          <a
            href={customPrivacyLink || 'https://aivy.app/datenschutz/'}
            className='font-medium text-gray-900 underline'
            target='_blank'
            rel='noreferrer'
          >
            {t('datapolicy_alt')}
          </a>
          {` ${t('datapolicy.description.second', { partnerName })}`}
        </p>
        {customPrivacyLinkReference && (
          <p className='mt-4 text-sm text-gray-700'>
            {t('datapolicy_additional')}
            <a
              href={customPrivacyLinkReference}
              className='ml-1 font-medium text-gray-900 underline'
              target='_blank'
              rel='noreferrer'
            >
              {`${partner.name} ${t('datapolicy_alt')}`}
            </a>
          </p>
        )}
      </div>
    </div>
  )
}

PrivacyPolice.propTypes = {
  partner: PropTypes.object.isRequired,
  agreed: PropTypes.bool.isRequired,
  setAgreed: PropTypes.func.isRequired
}

export default PrivacyPolice
